
function BrokenComponent() {
    throw new Error("Render error")
}

export default BrokenComponent
